import { FC } from 'react';
import { GridFilterItem } from '../../../common/grid/GridFilterItem';
import { GridFilterDateFromTo } from '../../../common/grid/GridFilterDateFromTo';
import { invitationHistoryListActions, InvitationHistoryListFilter } from '../../../../store/entities/invitationHistoryList';
import { GridFilterLogActionBy } from './GridFilterLogActionBy';
import { GridFilterLogType } from './GridFilterLogType';

interface Props {
  query: InvitationHistoryListFilter;
}

export const InvTabLogsFilter: FC<Props> = ({ query }) => {
  return (
    <>
      <GridFilterItem
        query={query}
        gridActions={invitationHistoryListActions}
        name="timestamp"
        title="invitation.log.timestamp"
        disableAutoClose={true}
        Component={GridFilterDateFromTo}
      />
      <GridFilterItem
        query={query}
        gridActions={invitationHistoryListActions}
        name="actionBy"
        title="invitation.log.actionBy"
        disableAutoClose={true}
        Component={GridFilterLogActionBy}
      />
      <GridFilterItem
        query={query}
        gridActions={invitationHistoryListActions}
        name="type"
        title="invitation.log.type"
        disableAutoClose={true}
        Component={GridFilterLogType}
      />
    </>
  );
};
